import React from 'react';

const Card = ({ title, count, icon, color }) => (
    <div className="card card-stats mb-4 mb-xl-0">
        <div className="card-body">
            <div className="row">
                <div className="col">
                    <h5 className="card-title text-uppercase text-muted mb-0">{title}</h5>
                    <span className="h2 font-weight-bold mb-0">{count}</span>
                </div>
                <div className="col-auto">
                    <div className={`icon icon-shape w-48px h-48px ${color} text-white rounded-circle shadow d-flex`}>
                        <i className={`font-size-14 ${icon}`} />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Card;


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/components/Card.js